<template>
  <div class="flex flex-col">
    <BookieRow
      v-for="bookie in bookies"
      :key="bookie.id"
      :bookie="bookie"
      :value="sliderValues[bookie.id]"
      @change="(val) => emit('change', bookie.id, val)"
    />
  </div>
</template>

<script setup lang="ts">
import BookieRow from './BookieRow.vue'

const props = defineProps<{
  bookies: { id: string, name: string; icon: string }[]
  sliderValues: Record<string, 0 | 1 | 2>
}>()

const emit = defineEmits<{
  (e: 'change', bookieId: string, value: 0 | 1 | 2): void
}>()
</script>

